import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '..';
import * as fromTrainingRequirement from './training-requirement.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');

// feature slice - training requirement
const getTrainingRequirementSubState = createSelector(
  getSharedAuditState,
  state => state.trainingRequirement
);

// training requirement slice selectors
const getTrainingRequirementSkeletonsState = createSelector(
  getTrainingRequirementSubState,
  state => state.trainingRequirementSkeletons
);
const getBusinessPersonWithTrainingSkeletonState = createSelector(
  getTrainingRequirementSubState,
  state => state.businessPersonWithTrainingSkeletons
);
const getTrainingRequirementAuditState = createSelector(
  getTrainingRequirementSubState,
  state => state.trainingRequirementAudit
);
const getTrainingGroupAuditState = createSelector(
  getTrainingRequirementSubState,
  state => state.trainingGroupAudit
);
const getTrainingGroupTrainingRequirementAuditState = createSelector(
  getTrainingRequirementSubState,
  state => state.trainingGroupTrainingRequirementAudit
);
const getBusinessPersonTrainingRequirementAuditState = createSelector(
  getTrainingRequirementSubState,
  state => state.businessPersonTrainingRequirementAudit
);
const getWarningRuleAuditState = createSelector(
  getTrainingRequirementSubState,
  state => state.warningRuleAudit
);
const getTrainingGroupSkeletonState = createSelector(
  getTrainingRequirementSubState,
  state => state.trainingGroupSkeletons
);

//training group skeletons
export const getTrainingGroupSkeletonsLoaded = createSelector(
  getTrainingGroupSkeletonState,
  state => state.loaded
);
export const getTrainingGroupSkeletonsLoading = createSelector(
  getTrainingGroupSkeletonState,
  state => state.loading
);

// training requirement skeletons
export const getTrainingRequirementSkeletonsLoaded = createSelector(
  getTrainingRequirementSkeletonsState,
  state => state.loaded
);
export const getTrainingRequirementSkeletonsLoading = createSelector(
  getTrainingRequirementSkeletonsState,
  state => state.loading
);
// const getTrainingRequirementSkeletonsError = createSelector(
//   getTrainingRequirementSkeletonsState,
//   state => state.error
// );
// const getTrainingRequirementSkeletons = createSelector(
//   getTrainingRequirementSkeletonsState,
//   getTrainingRequirementSkeletonsLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
export const getTrainingRequirementAuditSkeletons = createSelector(
  getTrainingRequirementSkeletonsState,
  fromTrainingRequirement.trainingRequirementSkeletonSelectors.selectAll
);
export const getTrainingGroupAuditSkeletons = createSelector(
  getTrainingGroupSkeletonState,
  fromTrainingRequirement.trainingGroupSkeletonSelectors.selectAll
);
// business person training requirement skeletons
export const getbusinessPersonWithTrainingSkeletonsLoaded = createSelector(
  getBusinessPersonWithTrainingSkeletonState,
  state => state.loaded
);
export const getBusinessPersonWithTrainingSkeletonsLoading = createSelector(
  getBusinessPersonWithTrainingSkeletonState,
  state => state.loading
);
// const getBusinessPersonWithTrainingSkeletonsError = createSelector(
//   getBusinessPersonWithTrainingSkeletonState,
//   state => state.error
// );
// const getBusinessPersonWithTrainingSkeletons = createSelector(
//   getTrainingRequirementSkeletonsState,
//   getTrainingRequirementSkeletonsLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
export const getBusinessPersonWithTrainingAuditSkeletons = createSelector(
  getBusinessPersonWithTrainingSkeletonState,
  fromTrainingRequirement.businessPersonWithTrainingSkeletonSelectors.selectAll
);

// training requirement audits
export const getTraininigRequirementAuditLoaded = createSelector(
  getTrainingRequirementAuditState,
  state => state.loaded
);
export const getTrainingRequirementAuditLoading = createSelector(
  getTrainingRequirementAuditState,
  state => state.loading
);
export const getTrainingRequirementAudits = createSelector(
  getTrainingRequirementAuditState,
  fromTrainingRequirement.trainingRequirementAuditSelectors.selectAll
);
// training group audits
export const getTrainingGroupAuditLoaded = createSelector(
  getTrainingGroupAuditState,
  state => state.loaded
);
export const getTrainingGroupAuditLoading = createSelector(
  getTrainingGroupAuditState,
  state => state.loading
);
export const getTrainingGroupAudits = createSelector(
  getTrainingGroupAuditState,
  fromTrainingRequirement.trainingGroupAuditSelectors.selectAll
);

// training group training requirement audits
export const getTrainingGroupTrainingRequirementAuditLoaded = createSelector(
  getTrainingGroupTrainingRequirementAuditState,
  state => state.loaded
);
export const getTrainingGroupTrainingRequirementAuditLoading = createSelector(
  getTrainingGroupTrainingRequirementAuditState,
  state => state.loading
);
export const getTrainingGroupTrainingRequirementAudits = createSelector(
  getTrainingGroupTrainingRequirementAuditState,
  fromTrainingRequirement.trainingGroupTrainingRequirementAuditSelectors.selectAll
);

// business person training requirement audits
export const getBusinessPersonTraininigRequirementAuditLoaded = createSelector(
  getBusinessPersonTrainingRequirementAuditState,
  state => state.loaded
);
export const getBusinessPersonTrainingRequirementAuditLoading = createSelector(
  getBusinessPersonTrainingRequirementAuditState,
  state => state.loading
);
export const getBusinessPersonTrainingRequirementAudits = createSelector(
  getBusinessPersonTrainingRequirementAuditState,
  fromTrainingRequirement.businessPersonTrainingRequirementAuditSelectors.selectAll
);
// warning rule audits
export const getWarningRuleAuditLoaded = createSelector(
  getWarningRuleAuditState,
  state => state.loaded
);
export const getWarningRuleAuditLoading = createSelector(
  getWarningRuleAuditState,
  state => state.loading
);
export const getWarningRuleAudits = createSelector(
  getWarningRuleAuditState,
  fromTrainingRequirement.warningRuleAuditSelectors.selectAll
);
